import React, { Component } from "react";
import { Button, Row, Col } from "react-bootstrap";
import Navbar from "../Navbar/Navbar";
import Quote from "../Quote/Quote";
import Footer from "../Footer/Footer";
import { NavLink } from "react-router-dom";
import Loading from 'react-fullscreen-loading';
import ScrollAnimation from 'react-animate-on-scroll';


class Home extends Component {
  state = { isLoading: true };

  componentDidMount() {
    setTimeout(() => this.setState({ isLoading: false }), 600);
  }
  render() {
    if (!this.state.isLoading) {
      return (
        <div>
          <Navbar />
          <div className="home">
            <div
              className="main-home"
              style={{
                marginLeft: "50px",
                color: "rgb(15, 131, 131)",
                marginRight: "50px"
              }}
            >
              <ScrollAnimation animateIn="fadeInDown" animateOnce={true}>
                <h1 style={{ fontWeight: "bold",color: "rgb(15, 131, 131)" }}>
                  Al Quran
                </h1>
                <h5>
                  Learn Quran online with no hassle of going somewhere physically. 
                  <br />
                  Spend your life according to Quran.
                </h5>
              </ScrollAnimation>
              <br />
              <NavLink
                to="/courses"
                style={{ textDecoration: "none", color: "white" }}
              >
                <Button variant="success">Courses</Button>
              </NavLink>
            </div>
          </div>
          <Row>
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true}>
              <Quote />
            </ScrollAnimation>
          </Row>
          <Footer />
        </div>
      );
    } else {
      return <Loading loading background="#eee" loaderColor="rgb(15,131,131)" />;
    }
  }
}
export default Home;
